/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { InvokeCreator, DoneInvokeEvent, Actions, createMachine } from "xstate";
import { deleteDialogMachineConfig, DeleteDialogTypeState } from "./delete-dialog-machine";

type CrudMachineProps = {
    submit: InvokeCreator<any, any>;
    deleteEntity: InvokeCreator<any, any>;
    onSubmit: Actions<CrudMachineContext, DoneInvokeEvent<any>>;
    onDelete: Actions<CrudMachineContext, DoneInvokeEvent<string>>;
};

type CrudMachineContext = {};

export type CrudMachineTypeState = (
    | {
          value: "idle";
      }
    | {
          value: { idle: "validation" };
      }
    | {
          value: "idle.validation.valid";
      }
    | {
          value: "idle.validation.invalid";
      }
    | {
          value: "idle.deleteConfirmation";
      }
    | DeleteDialogTypeState<CrudMachineContext, "idle.deleteConfirmation">
    | {
          value: "submitting";
      }
    | {
          value: "failure";
      }
    | {
          value: "finished";
      }
) & { context: CrudMachineContext };

type CrudMachineEvents =
    | { type: "SUBMIT"; payload: any }
    | { type: "DELETE" }
    | { type: "INVALID" }
    | { type: "VALID" }
    | { type: "CONFIRM_DELETE"; payload: string }
    | { type: "CANCEL_DELETE" };

export const crudMachine = ({ submit, deleteEntity, onSubmit, onDelete }: CrudMachineProps) =>
    createMachine<CrudMachineContext, CrudMachineEvents, CrudMachineTypeState>({
        id: "crud",
        context: {},
        initial: "idle",
        states: {
            idle: {
                type: "parallel",
                states: {
                    validation: {
                        initial: "invalid",
                        states: {
                            valid: {
                                on: {
                                    SUBMIT: "#submitting",
                                    INVALID: "invalid",
                                },
                            },
                            invalid: {
                                on: {
                                    VALID: "valid",
                                },
                            },
                        },
                    },
                    deleteConfirmation: deleteDialogMachineConfig<CrudMachineContext, string, any>(deleteEntity, onDelete, "#finished", "#failure"),
                },
            },
            submitting: {
                id: "submitting",
                invoke: {
                    src: submit,
                    onDone: { target: "finished", actions: onSubmit },
                    onError: "failure",
                },
            },
            failure: {
                id: "failure",
                type: "final",
            },
            finished: {
                id: "finished",
                type: "final",
            },
        },
    });
